import React from "react";
import Section1 from "../components/Allcontent/Section1";
import data from '../json/Careerpage/Careerpage.json'
import Openings from "../components/Careerpage/Openings";

const Career = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Section1 data={data}/>
      <Openings data={data}/>
    </div>
  );
};

export default Career;
